import { useId } from 'react';

export function Tabs({ tabs, value, onChange, label, dir = 'ltr' }) {
  const baseId = useId();

  const onKeyDown = (event) => {
    const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (!keys.includes(event.key)) {
      return;
    }
    event.preventDefault();
    const index = tabs.findIndex((tab) => tab.id === value);
    const last = tabs.length - 1;
    const nextKey = dir === 'rtl' ? 'ArrowLeft' : 'ArrowRight';
    const prevKey = dir === 'rtl' ? 'ArrowRight' : 'ArrowLeft';
    let nextIndex = index;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = last;
    else if (event.key === nextKey) nextIndex = index >= last ? 0 : index + 1;
    else if (event.key === prevKey) nextIndex = index <= 0 ? last : index - 1;
    const next = tabs[nextIndex];
    if (next) {
      onChange(next.id);
      document.getElementById(`${baseId}-${next.id}`)?.focus();
    }
  };

  return (
    <div className="tab-list" role="tablist" aria-label={label} onKeyDown={onKeyDown}>
      {tabs.map((tab) => {
        const selected = tab.id === value;
        return (
          <button
            key={tab.id}
            id={`${baseId}-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={selected ? 'tab is-active' : 'tab'}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
